module.exports = __webpack_public_path__ + "media/team/valentine-99f84a7a.png";